<template>
  <div>
    <a-space style="margin-bottom: 10px">
      <a-input-search v-model="formData.productKeyword" placeholder="输入产品名称/代码" @search="() => getList()" @pressEnter="() => getList()" />
      <animal-list @setVal="changeForm" feild="animalTypeCode" />
    </a-space>
    <a-table
      :columns="columns"
      :loading="ImportProductLibraryLoading"
      :data-source="list.records"
      :row-selection="{ selectedRowKeys, onChange: onSelectChange,getCheckboxProps }"
      row-key="id"
      :pagination="pagination"
      @change="listChange"
      :scroll="{y: 300}"
    >
    </a-table>
  </div>
</template>
<script>
import { nhfMixins } from "../../untils";
import AnimalList from '@/components/Common/components/AnimalList.vue'
import { getRequest } from "@/components/Common/Utils/Utils";
export default {
  mixins: [nhfMixins],
  components: {AnimalList},
  data(){
    return {
      columns: [
        {
          title: "产品名称",
          dataIndex: "productName",
          width: 100,
          ellipsis: true,
        },
        {
          title: "配方代码",
          dataIndex: "formulaCode",
          width: 160,
          ellipsis: true,
        },
        {
          title: "版本",
          dataIndex: "version",
          width: 80,
          ellipsis: true,
        },
        {
          title: "动物类型",
          dataIndex: "animalTypeName",
          width: 100,
          ellipsis: true,
        },
        {
          title: "工厂名称",
          dataIndex: "factoryName",
          width: 160,
          ellipsis: true,
        },
        {
          title: "营养师",
          dataIndex: "staffName",
          width: 100,
          ellipsis: true,
        },
      ],
      factoryId: window.localStorage.getItem('factoryId'),
      staffId: window.localStorage.getItem('staffId'),
      formData: {
        productKeyword: undefined,
        animalId: undefined,
      }
    }
  },
  watch: {
    selectedRows: {
      handler(val){
        this.$emit('selectLen',val.length)
      },
      deep: true,
    }
  },
  mounted(){
    this.getList()
  },
  methods: {
    changeForm(data){
      this.formData = {...this.formData,...data}
      this.getList()
    },
    listChange(page) {
      this.getList({ ...this.tablePageChange(page), ...this.filterData ,...this.search});
    },
    getList(arg = {}) {
      let {current=1,size=20} = arg || {}
      const data = {
        isActivate: 1,
        factoryId: this.factoryId,
        staffId: this.staffId,
        formulaId: getRequest('id'),
        status: 0,
        query: {current,size},
        ...this.formData,
      };
      this.ImportProductFactoryLoading = true
      this.fetchPost({
        actions: this.getNonInCustomFormulaProductPageByCond,
        isList: true,
        data,
        name: "list",
        loading: "ImportProductFactoryLoading",
        showMessage: false
      });
    },
  }
}
</script>